import { graphql } from "@/gql";

export const CHECK_IN_QUERY = graphql(`
  query CHECK_IN_QUERY($id: String!) {
    checkIn(id: $id) {
      id
      organizationId
      shortId
      createdAt
      memberId
      member {
        id
        fullName
        displayName
        avatarUrl
        ...CHECK_IN_MEMBER_DETAILS_FRAGMENT
      }
      ...CHECK_IN_LOCATION_DETAILS_FRAGMENT
      ...CHECK_IN_MAP_FRAGMENT
    }
  }
`);

export const CHECK_IN_MEMBER_DETAILS_FRAGMENT = graphql(`
  fragment CHECK_IN_MEMBER_DETAILS_FRAGMENT on Member {
    id
    organizationId
    fullName
    displayName
    timezone
    avatarUrl
    phoneNumber
    emailAddress
    metadata
    lastActiveAt
    organization {
      id
      memberMetadataFields
    }
  }
`);

export const CHECK_IN_LOCATION_DETAILS_FRAGMENT = graphql(`
  fragment CHECK_IN_LOCATION_DETAILS_FRAGMENT on CheckIn {
    id
    organizationId
    coordinates {
      x
      y
    }
    geocode {
      id
      address
      plusCode
    }
    places {
      nodes {
        id
        name
        spatialData {
          geojson
        }
        radius
        center {
          longitude
          latitude
        }
      }
    }
    organization {
      id
      places {
        nodes {
          id
          name
          spatialData {
            geojson
          }
          radius
          center {
            longitude
            latitude
          }
        }
      }
    }
  }
`);

export const CHECK_IN_MAP_FRAGMENT = graphql(`
  fragment CHECK_IN_MAP_FRAGMENT on CheckIn {
    id
    organizationId
    coordinates {
      x
      y
    }
    member {
      id
      avatarUrl
      displayName
      fullName
    }
    places {
      nodes {
        id
        name
        center {
          latitude
          longitude
        }
        radius
        spatialData {
          geojson
        }
      }
    }
  }
`);
